import _ from 'lodash';
import { Configure, connectHits, InstantSearch } from 'react-instantsearch-dom';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import algoliasearch from 'algoliasearch';
import React from 'react';

import { URLS } from '@/constants';
import CardListing from '@/components/card-listing';
import { getVehicleImages } from '@/utils/get-vehicle-image/index';

import buildQuery from './utils/build-query';
import filterResults from './utils/filter-results';
import { type Dispatch } from '@/app-state/store';

const searchClient = algoliasearch(
  `${process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID}`,
  `${process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_API_KEY}`,
  {}
);

// For safety features, we need algolia to return everything it can so we can filter it down ourselves.
const SAFETY_FEATURE_HITS_LIMIT = 1000;

const mapDispatch = (dispatch: Dispatch) => ({
  filterActions: dispatch.filters,
});

/**
 * Component that wraps our CardListing in a HOC provided by algolia to get the results from the InstantSearch.
 */
const ConnectedCardListing = connect(
  null,
  mapDispatch
)(
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'filterActions' does not exist on type 'HitsProvided<BasicDoc>'.
  connectHits(({ filterActions, hits, safetyFeature }) => {
    const router = useRouter();

    let vehicles = _.map(hits, (hit) => ({
      ...hit,
      newPrice: hit.newPrice,
      priceRange: { low: hit.privateMinPrice, high: hit.privateMaxPrice },
      image: hit.image || undefined,
    }));

    vehicles = filterResults(vehicles);
    vehicles = getVehicleImages(vehicles);

    if (_.isEmpty(vehicles)) {
      return null;
    }

    const handleShowMoreClick = () => {
      filterActions.reset();
      filterActions.addSafetyFeature(safetyFeature.tacFeatureCode);
      router.push(URLS.RESULTS);
    };

    return (
      <CardListing
        // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ newPrice: string; priceRange: { low: string; high: string; }; image: string | undefined; objectID: string; _highlightResult: { [x: string]: HighlightResultPrimitive | undefined; }; }[]' is not assignable to type '(InferProps<{ ANCAPTestYear: Requireable<number>; image: Requireable<string>; make: Validator<string>; model: Validator<string>; priceRange: Requireable<...>; recommendedSafetyFeatures: Validator<...>; totalSafetyFeatures: Validator<...>; year: Validator<...>; }> | null | undefined)[]'.
        cars={vehicles}
        gtmEvent="carsWithThisFeature"
        hasShowMoreButton
        intro=""
        onShowMoreClick={handleShowMoreClick}
        title="Cars with this feature"
      />
    );
  })
);

type VehiclesWithSafetyFeatureProps = {
  safetyFeature: {
    tacFeatureCode: string;
  };
};

const VehiclesWithSafetyFeature = ({ safetyFeature }: VehiclesWithSafetyFeatureProps) => (
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call.
  <InstantSearch indexName={process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME} searchClient={searchClient}>
    <Configure filters={buildQuery(safetyFeature)} hitsPerPage={SAFETY_FEATURE_HITS_LIMIT} />
    <ConnectedCardListing {...{ safetyFeature }} />
  </InstantSearch>
);

export default VehiclesWithSafetyFeature;
